import React, { useContext, FC } from "react";
import LinearProgress from "@fv-components/linear-progress";
import useQueryRecentDocuments, { IDocument } from "../../../../util-api/useQueryRecentDocuments";
import ProjectContext from "../../../ProjectContext";
import Document from "../Document";

const css = require('./RecentDocuments.module.scss');

const RecentDocuments: FC = () => {
  const { currentProjectId } = useContext(ProjectContext);

  // Fetch recent documents using the new clean API
  const {
    data: documents,
    isLoading: loading
  } = useQueryRecentDocuments(currentProjectId ?? null);

  if (!loading && documents?.items?.length === 0) {
    return null;
  }

  return (
    <div className={css.recentDocumentsContainer}>
      <div className={css.recentDocumentsTitle}>My Recent Docs</div>
      {loading ? <LinearProgress /> : documents?.items?.map((doc: IDocument) => (
        <Document doc={doc} key={doc.documentId.native} showSimpleDisplay />
      ))}
    </div>
  );
};

export default RecentDocuments;